'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxPagan = require('redux-pagan');
var _reactRedux = require('react-redux');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _components = require('../../components');

var _advancedFilters = require('../../redux/modules/advancedFilters');

var _constants = require('../../constants');
var _routerAdapter = require('../../helpers/routerAdapter');

var _AdvancedFilters = require('./AdvancedFilters.scss');var styles = _interopRequireWildcard(_AdvancedFilters);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
// Styles
var fields = Object.keys(_constants.advancedFiltersInitialValues);var AdvancedFilters = function (_Component) {_inherits(AdvancedFilters, _Component);
  function AdvancedFilters(props) {_classCallCheck(this, AdvancedFilters);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.



















































































    handleClose = function () {
      _this.clearFilters();
      _this.props.hideAdvancedFilters();
    };_this.

    handleChange = function (field, value) {var _this$setState;
      _this.setState((_this$setState = {}, _this$setState[field] = value, _this$setState));
      if (_this.props.isMobile) {var _Object$assign;
        _this.props.handleChange('advancedFilters', Object.assign({}, _this.state, (_Object$assign = {}, _Object$assign[field] = value, _Object$assign)));
      }
    };_this.

    handleChangeCommodities = function (value) {
      var values = [].concat(_this.state.commodities);
      var index = _this.state.commodities.indexOf(value);
      if (index >= 0) {
        values.splice(index, 1);
      } else {
        values.push(value);
      }
      _this.setState({ commodities: values });
      if (_this.props.isMobile) {
        _this.props.handleChange('advancedFilters', Object.assign({}, _this.state, { commodities: values }));
      }
    };_this.

    handleCheckMaxValue = function (field) {var _this$state$field =
      _this.state[field],min = _this$state$field.min,max = _this$state$field.max;
      var minValue = +min;
      var maxValue = +max;

      if (minValue >= 0 && max < minValue) {var _this$setState2;
        _this.setState((_this$setState2 = {}, _this$setState2[field] = { min: min, max: 0 }, _this$setState2));
      }
      if (field === 'constructionYear') {
        if (minValue >= 0 && (minValue < _constants.constructionYearMin || minValue > _constants.constructionYearMax)) {var _this$setState3;
          _this.setState((_this$setState3 = {}, _this$setState3[field] = { min: 0, max: maxValue }, _this$setState3));
        }
        if (maxValue >= 0 && (maxValue < _constants.constructionYearMin || maxValue > _constants.constructionYearMax)) {var _this$setState4;
          _this.setState((_this$setState4 = {}, _this$setState4[field] = { min: minValue, max: 0 }, _this$setState4));
        }
        if (minValue >= 0 && (minValue < _constants.constructionYearMin || minValue > _constants.constructionYearMax) &&
        maxValue > 0 && (maxValue < _constants.constructionYearMin || maxValue > _constants.constructionYearMax)) {var _this$setState5;
          _this.setState((_this$setState5 = {}, _this$setState5[field] = { min: 0, max: 0 }, _this$setState5));
        }
      }
    };_this.

    clearFilters = function () {return _this.setState(Object.assign({}, _constants.advancedFiltersInitialValues, {

        commodities: [],
        toilets: ['all'],
        bathrooms: ['all'],
        constructionYear: {},
        area: {} }));};var _props$routeData = props.routeData,_props$routeData$para = _props$routeData.params,_props$routeData$para2 = _props$routeData$para.notLastFloor,notLastFloor = _props$routeData$para2 === undefined ? null : _props$routeData$para2,_props$routeData$para3 = _props$routeData$para.parkingSpot,parkingSpot = _props$routeData$para3 === undefined ? null : _props$routeData$para3,_props$routeData$para4 = _props$routeData$para.elevator,elevator = _props$routeData$para4 === undefined ? null : _props$routeData$para4,_props$routeData$para5 = _props$routeData$para.balcony,balcony = _props$routeData$para5 === undefined ? null : _props$routeData$para5,_props$routeData$para6 = _props$routeData$para.photos,photos = _props$routeData$para6 === undefined ? null : _props$routeData$para6,_props$routeData$para7 = _props$routeData$para.vr,vr = _props$routeData$para7 === undefined ? null : _props$routeData$para7,_props$routeData$para8 = _props$routeData$para.commodities,commodities = _props$routeData$para8 === undefined ? [] : _props$routeData$para8,toilets = _props$routeData$para.toilets,bathrooms = _props$routeData$para.bathrooms,floor = _props$routeData$para.floor,area = _props$routeData$para.area,constructionYear = _props$routeData$para.constructionYear,_props$routeData$para9 = _props$routeData$para.price,minPrice = _props$routeData$para9.minPrice,maxPrice = _props$routeData$para9.maxPrice,location = _props$routeData.location;_this.state = props.isMobile && location !== '' ? { floor: floor ? { min: floor.min, max: floor.max } : Object.assign({}, _constants.advancedFiltersInitialValues.floor), notLastFloor: notLastFloor, parkingSpot: parkingSpot, elevator: elevator, balcony: balcony, photos: photos, vr: vr, commodities: commodities, price: { minPrice: minPrice || '', maxPrice: maxPrice || '' }, area: area || {}, constructionYear: constructionYear || {}, toilets: toilets || ['all'], bathrooms: bathrooms || ['all'] } : Object.assign({}, _constants.advancedFiltersInitialValues, { price: { minPrice: minPrice || '', maxPrice: maxPrice || '' }, area: area || {}, constructionYear: constructionYear || {}, toilets: toilets || ['all'], bathrooms: bathrooms || ['all'] });return _this;}AdvancedFilters.prototype.componentDidMount = function componentDidMount() {if (!this.props.resetButtonId) {return;} // Why not simple onclick?
    this.resetButton = document.querySelector('#' + this.props.resetButtonId);this.resetButton.addEventListener('click', this.clearFilters);if (this.props.resetAdvancedFilters) {this.clearFilters();}};AdvancedFilters.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var isAdvancedFiltersOpen = newProps.isAdvancedFiltersOpen,params = newProps.routeData.params;var parameters = params.commodities ? Object.assign({}, params, { commodities: [].concat(params.commodities) }) : Object.assign({}, params);if (isAdvancedFiltersOpen && !this.props.isAdvancedFiltersOpen) {var fieldsData = {};fields.forEach(function (field) {if (parameters[field]) {fieldsData[field] = parameters[field];}});if (!(0, _isEqual2.default)(this.state, fieldsData) && !(0, _isEmpty2.default)(fieldsData)) {this.setState(Object.assign({}, _constants.advancedFiltersInitialValues, fieldsData));}}};AdvancedFilters.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref, nextState) {var isAdvancedFiltersOpen = _ref.isAdvancedFiltersOpen,isMobile = _ref.isMobile;if (isMobile && !(0, _isEqual2.default)(nextState, this.state)) {this.props.getAdvancedFiltersValues(nextState);}if (!isMobile && !isAdvancedFiltersOpen && !this.props.isAdvancedFiltersOpen) {return false;}var _nextState$floor = nextState.floor,min = _nextState$floor.min,max = _nextState$floor.max;return !(max > 0 && min !== this.state.floor.min && min > max);};AdvancedFilters.prototype.componentWillUnmount = function componentWillUnmount() {if (this.resetButton) {this.resetButton.removeEventListener('click', this.clearFilters);}};AdvancedFilters.prototype.

  renderFilters = function renderFilters() {var _this2 = this;var _props =
    this.props,translate = _props.translate,locale = _props.locale,isMobile = _props.isMobile,optionType = _props.routeData.optionType;
    var photosFieldData = {
      value: this.state.photos,
      checked: this.state.photos,
      onChange: function onChange() {return _this2.handleChange('photos', !_this2.state.photos);} };

    var vrFieldData = {
      value: this.state.vr,
      checked: this.state.vr,
      onChange: function onChange() {return _this2.handleChange('vr', !_this2.state.vr);} };

    return (
      _react2.default.createElement('div', { className: styles.filters },
        _react2.default.createElement(_components.QuantitativeFilters, {
          onChange: this.handleChange,
          handleCheckMaxValue: this.handleCheckMaxValue,
          fields: this.state,
          translate: translate,
          isMobile: isMobile }),

        _react2.default.createElement(_components.AdditionalFilters, {
          translate: translate,
          locale: locale,
          onChange: this.handleChangeCommodities,
          photosField: photosFieldData,
          vrField: vrFieldData,
          commodities: this.state.commodities,
          onBathToiletsChange: this.handleChange,
          bathrooms: this.state.bathrooms,
          toilets: this.state.toilets,
          location: (0, _get2.default)(this.props, 'routeData.location') || _constants.sections.homes.location,
          optionType: isMobile ? this.props.optionType : optionType })));



  };AdvancedFilters.prototype.

  render = function render() {var _props2 =
    this.props,isAdvancedFiltersOpen = _props2.isAdvancedFiltersOpen,translate = _props2.translate,isMobile = _props2.isMobile,routeData = _props2.routeData;
    if (isMobile) {
      return (
        _react2.default.createElement('div', null, this.renderFilters()));

    }
    return (
      _react2.default.createElement(_components.Modal, {
          className: 'advancedFiltersModal',
          isOpen: isAdvancedFiltersOpen,
          onRequestClose: this.handleClose,
          translate: translate,
          isRtl: this.props.isRtl },

        this.renderFilters(),
        _react2.default.createElement(_components.ButtonsFormsControls, {
          className: 'modalFooter',
          fields: this.state,
          resetForm: this.clearFilters,
          translate: translate,
          routeData: routeData,
          hideAdvancedFilters: this.props.hideAdvancedFilters })));



  };return AdvancedFilters;}(_react.Component);


AdvancedFilters.propTypes = {
  isAdvancedFiltersOpen: _propTypes2.default.bool,
  hideAdvancedFilters: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  routeData: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  scrollTop: _propTypes2.default.func,
  getAdvancedFiltersValues: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  resetAdvancedFilters: _propTypes2.default.bool,
  resetButton: _propTypes2.default.object,
  resetButtonId: _propTypes2.default.string,
  handleChange: _propTypes2.default.func,
  optionType: _propTypes2.default.string };


var mapStateToProps = function mapStateToProps(_ref2)




{var routing = _ref2.routing,isAdvancedFiltersOpen = _ref2.advancedFilters.isAdvancedFiltersOpen,lang = _ref2.lang,isMobile = _ref2.windowDimentions.isMobile;
  var routeData = (0, _routerAdapter.extractRouteData)(routing, lang.locale);
  return {
    routeData: routeData,
    translate: (0, _reduxPagan.getLang)(lang, 'static'),
    isAdvancedFiltersOpen: isAdvancedFiltersOpen,
    locale: routeData.locale,
    isMobile: isMobile };

};exports.default =

(0, _reactRedux.connect)(mapStateToProps, { hideAdvancedFilters: _advancedFilters.hideAdvancedFilters })(
AdvancedFilters);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AdvancedFilters/AdvancedFilters.js
// module id = 2920
// module chunks = 0